import type { SVGProps } from "react"

export const SvgClosedCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32" 
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props} 
  >
    <path
      fill="#231F20"
      d="M28.8 3.84h-1.92V2.56a1.28 1.28 0 0 0-1.28-1.28h-1.28a1.28 1.28 0 0 0-1.28 1.28v1.28h-5.12V2.56a1.28 1.28 0 0 0-1.28-1.28h-1.28a1.28 1.28 0 0 0-1.28 1.28v1.28H8.96V2.56a1.28 1.28 0 0 0-1.28-1.28H6.4a1.28 1.28 0 0 0-1.28 1.28v1.28H3.2a1.92 1.92 0 0 0-1.92 1.92V28.8a1.92 1.92 0 0 0 1.92 1.92h25.6a1.92 1.92 0 0 0 1.92-1.92V5.76a1.92 1.92 0 0 0-1.92-1.92m-4.48-1.28h1.28V6.4h-1.28zm-8.96 0h1.28V6.4h-1.28zm-8.96 0h1.28V6.4H6.4zM3.2 5.12h1.92V6.4A1.28 1.28 0 0 0 6.4 7.68h1.28A1.28 1.28 0 0 0 8.96 6.4V5.12h5.12V6.4a1.28 1.28 0 0 0 1.28 1.28h1.28a1.28 1.28 0 0 0 1.28-1.28V5.12h5.12V6.4a1.28 1.28 0 0 0 1.28 1.28h1.28a1.28 1.28 0 0 0 1.28-1.28V5.12h1.92a.64.64 0 0 1 .64.64v4.48H2.56V5.76a.64.64 0 0 1 .64-.64m25.6 24.32H3.2a.64.64 0 0 1-.64-.64V11.52h26.88V28.8a.64.64 0 0 1-.64.64"
    ></path>
    <path
      fill="#231F20"
      d="M20.262 15.513a.653.653 0 0 0-.909.064L16 19.494l-3.354-3.917a.644.644 0 1 0-.973.845l3.482 4.058-3.482 4.057a.65.65 0 0 0 .064.91.653.653 0 0 0 .91-.065L16 21.465l3.353 3.917a.653.653 0 0 0 .91.064.653.653 0 0 0 .063-.909l-3.481-4.057 3.481-4.058a.653.653 0 0 0-.064-.909"
    ></path>
  </svg>
);